<section class="content-header">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1>Profile</h1>
            </div>
            <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                    <li class="breadcrumb-item"><a href="#">Home</a></li>
                    <li class="breadcrumb-item active">User Profile</li>
                </ol>
            </div>
        </div>
    </div>
</section>

<section class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-3">
                <div class="card card-primary card-outline">
                    <div class="card-body box-profile">
                        <div class="text-center">
                            <!-- <pf-image
                                class="profile-image"
                                [rounded]="true"
                                [src]="user.photoURL"
                                fallbackSrc="assets/img/default-profile.png"
                                alt="User profile"
                                width="100"
                                height="100"
                            /> -->
                        </div>
                        <h3 class="profile-username text-center">
                            {{ user?.displayName }}
                        </h3>
                        <p class="text-muted text-center">Software Engineer</p>

                        <ul class="list-group list-group-unbordered mb-3">
                            <li class="list-group-item">
                                <b>Followers</b>
                                <a class="float-right">1,402</a>
                            </li>
                            <li class="list-group-item">
                                <b>Following</b> <a class="float-right">543</a>
                            </li>
                            <li class="list-group-item">
                                <b>Friends</b> <a class="float-right">13,287</a>
                            </li>
                        </ul>
                        <a href="#" class="btn btn-primary btn-block"
                            ><b>Follow</b></a
                        >
                    </div>
                </div>
                <div class="card card-primary">
                    <div class="card-header">
                        <h3 class="card-title">About Me</h3>
                    </div>
                    <div class="card-body">
                        <strong
                            ><i class="fas fa-book mr-1"></i> Education</strong
                        >
                        <p class="text-muted">
                            B.S. in Computer Science from the University of
                            Tennessee at Knoxville
                        </p>
                        <hr />

                        <strong>
                            <i class="fas fa-map-marker-alt mr-1"></i>
                            Location
                        </strong>

                        <p class="text-muted">Malibu, California</p>
                        <hr />
                        <strong
                            ><i class="fas fa-pencil-alt mr-1"></i
                            >{{ 'main.label.skills' }}</strong
                        >
                        <p class="text-muted">
                            <span class="tag tag-danger">UI Design</span>
                            <span class="tag tag-success">Coding</span>
                            <span class="tag tag-info">Javascript</span>
                            <span class="tag tag-warning">PHP</span>
                            <span class="tag tag-primary">Node.js</span>
                        </p>
                        <hr />
                        <strong
                            ><i class="far fa-file-alt mr-1"></i
                            >{{ 'main.label.notes' }}</strong
                        >
                        <p class="text-muted">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Etiam fermentum enim neque.
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-9">
                <div class="card">
                    <div class="card-header p-2">
                        <ul class="nav nav-pills">
                            <li class="nav-item">
                                <pf-button
                                    class="tab-button"
                                    [variant]="
                                        (activeTab$ | async) === 'ACTIVITY'
                                            ? 'primary'
                                            : 'light'
                                    "
                                    (click)="toggle('ACTIVITY')"
                                >
                                    Activity
                                </pf-button>
                            </li>
                            <li class="nav-item">
                                <pf-button
                                    class="tab-button"
                                    [variant]="
                                        (activeTab$ | async) === 'TIMELINE'
                                            ? 'primary'
                                            : 'light'
                                    "
                                    (click)="toggle('TIMELINE')"
                                >
                                    Timeline
                                </pf-button>
                            </li>
                            <li class="nav-item">
                                <pf-button
                                    class="tab-button"
                                    [variant]="
                                        (activeTab$ | async) === 'SETTINGS'
                                            ? 'primary'
                                            : 'light'
                                    "
                                    (click)="toggle('SETTINGS')"
                                >
                                    Settings
                                </pf-button>
                            </li>
                        </ul>
                    </div>
                    <div class="card-body">
                        <div class="tab-content">
                            <app-activity-tab
                                *ngIf="(activeTab$ | async) === 'ACTIVITY'"
                            ></app-activity-tab>
                            <app-timeline-tab
                                *ngIf="(activeTab$ | async) === 'TIMELINE'"
                            ></app-timeline-tab>
                            <app-settings-tab
                                *ngIf="(activeTab$ | async) === 'SETTINGS'"
                            ></app-settings-tab>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
